import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { PermitStepActions } from "../../../permit/states/permit-step.action";
import { PermitStepSelectors } from "../../../permit/states/permit-step.selectors";
import { Permit } from "../../models/permit.model";
import { CustomerQuestionAnswer } from "../../models/question.model";
import { PermitCreateSelectors } from "../../states/permit-create.selectors";

@UntilDestroy()
@Component({
    selector: "pmt-gasfree-cert",
    templateUrl: "permit-gasfree-cert.component.html",
    styleUrls: ["permit-gasfree-cert.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitGasfreeCertComponent implements OnInit {
    @Select(PermitCreateSelectors.permit)
    public permit$: Observable<Permit>;

    public currentCustomerAnswer: CustomerQuestionAnswer;
    public CustomerQuestionAnswer = CustomerQuestionAnswer;

    public get canProceed() {
        return this.currentCustomerAnswer && this.currentCustomerAnswer == CustomerQuestionAnswer.No;
    }

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.currentCustomerAnswer = this.store.selectSnapshot(PermitStepSelectors.gasfreeCertificationAnswer);
    }

    public goBack(): void {
        this.store.dispatch(new PermitStepActions.GoBackwards());
    }

    public continue(): void {
        this.store.dispatch(new PermitStepActions.GoForward());
    }

    public select(answer: CustomerQuestionAnswer) {
        this.currentCustomerAnswer = answer;
        this.store.dispatch(new PermitStepActions.SetGasfreeCertAnswer(answer));
    }

    public createGasfreeCert(): void {
        var permitId = this.store.selectSnapshot(PermitCreateSelectors.permitId);
        this.store.dispatch(new PermitStepActions.CreateGasfreeCert(permitId));
    }
}
